import React from "react";

import { cn } from "../../../common/u1/cn";
import { CheckIcon } from "../../../../assets/ui/icons";

/* The chevron strip of years the manual form steps through. */
export const FinancialYearTabs = ({
  years = [],
  value,
  filled = [],
  onSelect,
  className = "",
}) => (
  <ol
    aria-label="Financial years"
    className={cn("m-0 flex list-none flex-wrap gap-1.5 p-0", className)}
  >
    {years.map((year) => {
      const active = year === value;
      const done = filled.includes(year);
      return (
        <li key={year} data-testid={`financial-year-${year}`} aria-current={active ? "step" : undefined}>
          <button
            type="button"
            onClick={() => onSelect?.(year)}
            aria-label={`Year ${year}${done ? " (has figures)" : ""}`}
            className={cn(
              "relative flex items-center gap-1.5 py-2 pl-4 pr-6 text-[13px] font-bold font-sans",
              "transition-colors focus-visible:outline-none focus-visible:ring-2",
              "focus-visible:ring-inset focus-visible:ring-[var(--orange)]",
              active
                ? "bg-[var(--navy)] text-white"
                : "bg-[var(--slate-2)] text-[var(--ink-2)] hover:bg-[var(--line)]"
            )}
            /* The chevron notch. A clip-path rather than a bordered pseudo
               element, so it scales with the label instead of assuming a
               width. */
            style={{
              clipPath:
                "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)",
              paddingLeft: 22,
            }}
          >
            Year {year}
            {done && (
              <span
                aria-hidden="true"
                className={active ? "text-[var(--orange)]" : "text-[var(--success)]"}
              >
                <CheckIcon size={11} />
              </span>
            )}
          </button>
        </li>
      );
    })}
  </ol>
);

export default FinancialYearTabs;
